/**
 * Self-service punch rules for the client.
 *
 * Mirrors apps/api-time/src/utils/self-punch.utils.ts so the UI can disable
 * controls the API would reject anyway. The server is the authority — this is
 * only here to avoid showing someone a clock that will 403 when they tap it.
 */
/**
 * Resolve the effective mode from a config response.
 *
 * Tolerates a response from an API deployed before per-employee scoping, which
 * carries only `mobilePunchEnabled`. Failing open here is deliberate: during a
 * rollout where the web app ships ahead of the API, the server still enforces
 * the real rule, and blocking the UI on a field the API does not send yet would
 * lock out everyone for no reason.
 */
export function resolveSelfPunchMode(config) {
    if (config?.mode === 'everyone' || config?.mode === 'selected' || config?.mode === 'nobody') {
        return config.mode;
    }
    return config?.mobilePunchEnabled === false ? 'nobody' : 'everyone';
}
/**
 * Decide whether a given employee may punch for themselves.
 *
 * Returns true while the config is still loading (`config` undefined) so the
 * clock does not flicker into a blocked state on every page load.
 */
export function isSelfPunchAllowed(config, employeeId) {
    if (!config)
        return true;
    const mode = resolveSelfPunchMode(config);
    switch (mode) {
        case 'everyone':
            return true;
        case 'nobody':
            return false;
        case 'selected':
            return Boolean(employeeId) && (config.allowedEmployeeIds ?? []).includes(employeeId);
        default:
            return false;
    }
}
